<template>
  <div class="general-filters">
    <div class="inner">
      <div class="title">Advanced Data Filters</div>
      <div class="wrap">
        <!-- Language -->
        <a-form-model layout="inline" :model="filter">
          <a-form-model-item label="Language">
            <a-radio-group v-model="filter.locale">
              <a-radio-button value="en-US"> English </a-radio-button>
              <a-radio-button value="zh-CN"> 中文 </a-radio-button>
              <!-- <a-radio-button value="fr-FR"> French </a-radio-button> -->
            </a-radio-group>
          </a-form-model-item>

          <!-- Location -->
          <a-form-model-item label="Location">
            <a-input v-model="filter.location" placeholder="Location" />
          </a-form-model-item>

          <!-- Services -->
          <a-form-model-item label="Services" prop="services">
            <a-select
              v-model="filter.services"
              default-value="interior_renovation"
              mode="multiple"
              style="width: 100%; min-width: 150px"
            >
              <a-select-option v-for="option in options_['SERVICE_TYPES']" :key="option.key" :value="option.key">
                {{ option.locales[locale] }}
              </a-select-option>
            </a-select>
          </a-form-model-item>

          <!-- Date Range -->
          <a-form-model-item label="Date Range">
            <a-input-group compact>
              <a-date-picker v-model="filter.start_date" style="width: 50%" />
              <a-date-picker v-model="filter.end_date" style="width: 50%" />
            </a-input-group>
          </a-form-model-item>

          <!-- Source -->
          <a-form-model-item label="Source">
            <a-input-group>
              <a-select v-model="filter.source" default-value="unknown" style="width: 100%; min-width: 150px">
                <a-select-option v-for="option in options_['GENERAL_SOURCES']" :key="option.key" :value="option.key">
                  {{ option.value }}
                </a-select-option>
              </a-select>
            </a-input-group>
          </a-form-model-item>

          <a-form-model-item>
            <a-button type="primary" @click="applyRules" :disabled="loading"> Apply </a-button>
          </a-form-model-item>

          <a-form-model-item>
            <a-button type="danger" @click="resetRules" :disabled="loading"> Reset </a-button>
          </a-form-model-item>
        </a-form-model>
      </div>
    </div>
  </div>
</template>

<script>
import * as recipientsService from '@/services/marketing/recipients'

export default {
  name: 'filters',
  data() {
    return {
      filter: {},
      loading: false,
    }
  },
  methods: {
    resetRules() {
      this.filter = {}
      this.$emit('onFilter', [])
    },
    async applyRules() {
      this.$emit('onFilter', await this.fetchRecipients(this.filter))
    },
    async fetchRecipients(filter) {
      if (filter && Object.keys(filter).length) {
        this.loading = true
        const filteredRecipients = await recipientsService.fetchRecipientsIdsByFilter(filter)
        this.loading = false
        return filteredRecipients
      }
      return []
    },
  },
  computed: {
    locale() {
      return this.$i18n.locale ? (this.$i18n.locale === 'zh-CN' ? 'zh' : 'en') : 'en'
    },
  },
}
</script>

<style lang="scss" scoped>
.general-filters {
  margin: 1rem 0;
  .inner {
    padding: 1rem;
    color: #595c97;
    border: 1px solid #e4e9f0;
    border-radius: 4px;
    transition: all 0.3s;

    .title {
      padding-bottom: 1rem;
    }

    .wrap {
      .rules {
        .field {
          width: 150px;
          padding: 4px 8px;
          color: #595c97;
          border: 1px solid #e4e9f0;
          border-radius: 4px;
          transition: all 0.3s;
        }
      }
      .actions {
        button {
          padding: 0.8rem 1.2rem;
          border: none;
        }
      }
    }
  }
}
</style>
